export default "__VITE_ASSET__B77loOaQ__"